import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=72aaa84a&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBanner.vue?vue&type=style&index=0&id=72aaa84a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aaa84a",
  null
  
)

export default component.exports